import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      textAlign: 'center',
    },
    textBlock: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      color: theme.palette.text.primary,
    },
  }),
);

export default function LibraryEmptyList(props: any) {
  const classes = useStyles(baseTheme);

  return (
    <Grid item container direction="column" className={classes.root}>
        <Grid item container direction="column">
          <Typography className={classes.textBlock}>
              To begin building your library, click on “Leaders” and copy a post.
          </Typography>
        </Grid>
    </Grid>
  );
}
